import {ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {Product} from '../../../models/product.model';
import {AuthService} from "../../../services/auth.service";

@Component({
  selector: 'app-brief-product-info',
  templateUrl: './brief-product-info.component.html',
  styleUrls: ['./brief-product-info.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BriefProductInfoComponent implements OnInit {

  @Input() product: Product;

  constructor(private auth: AuthService) { }

  ngOnInit(): void {
  }

  get imageUrl(): string {
    return this.product.thumbnail;
  }

  get isLinkDisabled(): boolean {
    return this.auth.isRestricted;
  }

  get price(): number {
    return this.product.getPrice();
  }


}
